import { basicInitialState } from 'store/_utils/basicInitialState';
import { TProductState } from './productModel';

export const productInitialState: TProductState = {
  ...basicInitialState,
  isNotFound: false,
  product: null
};
